import React, { Component } from "react";
import { Link } from "gatsby";
import ServiceSection from "../services/services-section";

class CompanySection extends Component {
  state = {};
  render() {
    return (
      <section id="company-section">
        <div className="container my-company-pt pb-5">
          <div className="row">
            <div className="col-md-6 my-company-pt pb-5">
              <p className="head-top-desc">Our Story</p>
              <h2 className="my-h2-head mb-md-4">ABOUT US</h2>

              <p className="desc mb-md-4">
                We are a Social Media Marketing Agency founded here in Thunder
                Bay to deliver our services toward small business in the Dental
                and Chiropractic sector.
              </p>

              <p className="desc mb-md-4">
                Being one of the newest Social Media Marketing Agencies here in
                Ontario really gives us a competitive advantage. This is because
                we can apply advanced marketing techniques that are up-to-date
                with today's industry standards while providing exceptional
                services along the way.
              </p>

              <p className="desc mb-md-4">
                Our agency ensures that quality comes first, and we guarantee
                that our clients will be ecstatic from the results we provide,
                and also the high standards we set for ourselves.
              </p>
              <Link className="hero-cta-button" to="/">
                Descover More
              </Link>
            </div>

            <div className="col-md-6 my-pl-5 pt-5">
              <img
                className="img-fluid"
                src={require("../../../static/images/home-website-growth-img.png")}
              />
            </div>
          </div>
          <ServiceSection />
        </div>
      </section>
    );
  }
}

export default CompanySection;
